import { useLanguages } from '@openeducation/oe-it-providers';

export const useSupportedLanguage = () => {
  const { languagesData: supportedLanguages } = useLanguages();

  function getLanguageName(languageCode: string) {
    const language = supportedLanguages?.find(
      ({ code }) => code === languageCode
    );

    return language?.language;
  }

  return { supportedLanguages, getLanguageName };
};
